import React from 'react'
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { Box } from '@mui/material';

export default function ImageGallery({ gallery }) {
    return (
        <Box sx={{ width: '100%', height: '100%', display: 'grid', gridTemplateColumns: {md: 'repeat(3, 1fr)', xs: 'repeat(2, 1fr)'} }} gap={1} >
            {gallery.map((item) => (
                <Box key={item.imageUrl} height={'300px'}>
                    <Box
                        component={'img'}
                        srcSet={`${item.imageUrl}`}
                        src={`${item.imageUrl}`}
                        alt={item.imageUrl}
                        loading="lazy"
                        sx={{ height: 1, width: 1, objectFit: 'cover' }}
                    />
                </Box>
            ))}
        </Box>
    )
}